/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FoodTransactionHistoryItem
 */
export interface FoodTransactionHistoryItem {
    /**
     * Food order ID
     * @type {string}
     * @memberof FoodTransactionHistoryItem
     */
    id?: string;
    /**
     * Total amount paid in USD cents
     * @type {number}
     * @memberof FoodTransactionHistoryItem
     */
    amount?: number;
    /**
     * Formatted USD amount (e.g., "$12.50")
     * @type {string}
     * @memberof FoodTransactionHistoryItem
     */
    amountFormatted?: string;
    /**
     * Human-readable description with merchant name
     * @type {string}
     * @memberof FoodTransactionHistoryItem
     */
    description?: string;
    /**
     * Merchant name
     * @type {string}
     * @memberof FoodTransactionHistoryItem
     */
    merchant?: string;
    /**
     * Number of items in order
     * @type {number}
     * @memberof FoodTransactionHistoryItem
     */
    itemCount?: number;
    /**
     * Payment method used
     * @type {string}
     * @memberof FoodTransactionHistoryItem
     */
    paymentMethod?: string;
    /**
     * Amount of Fuel used (if any)
     * @type {number}
     * @memberof FoodTransactionHistoryItem
     */
    fuelUsed?: number;
    /**
     * Order timestamp
     * @type {Date}
     * @memberof FoodTransactionHistoryItem
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the FoodTransactionHistoryItem interface.
 */
export function instanceOfFoodTransactionHistoryItem(value: object): value is FoodTransactionHistoryItem {
    return true;
}

export function FoodTransactionHistoryItemFromJSON(json: any): FoodTransactionHistoryItem {
    return FoodTransactionHistoryItemFromJSONTyped(json, false);
}

export function FoodTransactionHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FoodTransactionHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'amountFormatted': json['amountFormatted'] == null ? undefined : json['amountFormatted'],
        'description': json['description'] == null ? undefined : json['description'],
        'merchant': json['merchant'] == null ? undefined : json['merchant'],
        'itemCount': json['itemCount'] == null ? undefined : json['itemCount'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'fuelUsed': json['fuelUsed'] == null ? undefined : json['fuelUsed'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function FoodTransactionHistoryItemToJSON(json: any): FoodTransactionHistoryItem {
    return FoodTransactionHistoryItemToJSONTyped(json, false);
}

export function FoodTransactionHistoryItemToJSONTyped(value?: FoodTransactionHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'amountFormatted': value['amountFormatted'],
        'description': value['description'],
        'merchant': value['merchant'],
        'itemCount': value['itemCount'],
        'paymentMethod': value['paymentMethod'],
        'fuelUsed': value['fuelUsed'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

